import React from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import Box from '@material-ui/core/Box';
import {makeStyles} from '@material-ui/core/styles';
import {WEB_SETTINGS} from '../../../constants/appUrls.constants';
import {isWebSettingsAllowed} from '../../templates/Web/WebSettings/allowedEmails';

// Tum dashboard'larin sol menusunde, logonun ustunde duran Panel + Site Ayarlari ikilisi.
// Menu ogeleriyle ayni gorsel dil: yuvarlak kose, notr zemin, hover'da marka rengi.
const useStyles = makeStyles(() => ({
    wrapper: {
        flex: '0 0 auto',
        marginTop: 'auto',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 8,
        padding: '10px 4px 10px',
        borderTop: '1px solid #e2e8f0',
    },
    // Mobil: kart icinde, mevcut aksiyonlarin devami olarak
    wrapperInline: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 8,
        marginTop: 16,
        paddingTop: 16,
        borderTop: '1px solid #e2e8f0',
    },
    action: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 7,
        padding: '13px 6px',
        borderRadius: 16,
        background: '#f1f5f9',
        color: '#475569',
        textDecoration: 'none',
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.2,
        textAlign: 'center',
        transition: 'background 0.2s ease, color 0.2s ease',
        '& i': {
            fontSize: 17,
            color: '#64748b',
            transition: 'color 0.2s ease',
        },
        '&:hover': {
            background: '#e6ebf2',
            color: '#1e293b',
            '& i': {
                color: '#d71f26',
            },
        },
        '&:focus': {
            outline: 'none',
        },
    },
    // Sayfasi henuz hazir olmayan aksiyon (Panel)
    actionSoon: {
        cursor: 'default',
        color: '#94a3b8',
        '& i': {
            color: '#94a3b8',
        },
        '&:hover': {
            background: '#f1f5f9',
            color: '#94a3b8',
            '& i': {
                color: '#94a3b8',
            },
        },
    },
    badge: {
        position: 'absolute',
        top: 6,
        right: 6,
        fontSize: 8.5,
        fontWeight: 700,
        letterSpacing: 0.3,
        textTransform: 'uppercase',
        color: '#8492a6',
        background: '#fff',
        border: '1px solid #e2e8f0',
        borderRadius: 999,
        padding: '1px 5px',
        lineHeight: 1.5,
    },
}));

export default function DashboardBottomActions({inline}) {
    const {t} = useTranslation();
    const classes = useStyles();

    const userEmail = useSelector((state) => state.profileReducer
        && state.profileReducer.profileData
        && state.profileReducer.profileData.profile
        && state.profileReducer.profileData.profile.email);

    // Burada getProfile cagrilmaz: dashboard'larin Sidebar'i render() icinde
    // tanimli oldugu icin her render'da yeni bilesen tipi olusuyor ve bu agac
    // komple remount ediliyor. Mount'ta dispatch etmek sonsuz donguye yol aciyordu.
    // Profili sayfanin kendisi cekiyor (componentDidMount).

    // Kademeli acilis: yalnizca izinli hesaplara gorunur
    if (!isWebSettingsAllowed(userEmail)) return null;

    return (
        <Box className={inline ? classes.wrapperInline : classes.wrapper}>
            <span
                className={`${classes.action} ${classes.actionSoon}`}
                title={t('enw-web-settings-soon', 'Yakında')}
            >
                <span className={classes.badge}>
                    {t('enw-web-settings-soon', 'Yakında')}
                </span>
                <i className="fas fa-chart-pie" />
                {t('enw-web-settings-nav_panel', 'Panel')}
            </span>

            <Link to={WEB_SETTINGS} className={classes.action}>
                <i className="fas fa-cog" />
                {t('enw-web-settings-page_title', 'Site Ayarları')}
            </Link>
        </Box>
    );
}
